import * as yup from 'yup';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const yupOptionalListItemArray = (opts?: {
  limit?: number;
  limitMessage?: string;
}) => {
  const { limit, limitMessage } = opts || {
    limit: 0
  };

  if (limit) {
    return yup
      .array()
      .nullable()
      .max(limit, limitMessage)
      .of(
        yup.object().shape({
          label: yup.string(),
          value: yup.number()
        })
      );
  }

  return yup
    .array()
    .nullable()
    .of(
      yup.object().shape({
        label: yup.string(),
        value: yup.number()
      })
    );
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const yupRequiredListItemArray = (msg: string) => {
  return yup
    .array()
    .min(1, msg)
    .required(msg)
    .of(
      yup.object().shape({
        label: yup.string(),
        value: yup.number()
      })
    );
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const yupOptionalListItem = () =>
  yup.object().nullable().shape({
    label: yup.string(),
    value: yup.number()
  });

export const yupMultilingual = () => {
  return yup.object().shape({
    ES: yup.string(),
    EN: yup.string()
  });
};
